"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildrenDocs = void 0;
const core_1 = require("@beautiful-eyes/core");
const children_template_be_1 = __importDefault(require("./children.template.be"));
require("./code-viewer.component");
require("./demo-name-badge.component");
require("./demo-ping-badge.component");
require("./demo-chip.component");
let ChildrenDocs = (() => {
    let _classDecorators = [(0, core_1.Component)({
            selector: 'ChildrenDocs',
            useTemplate: children_template_be_1.default,
            useStyleSheets: []
        })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = core_1.ReactiveClass;
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _pingName_decorators;
    let _pingName_initializers = [];
    let _pingName_extraInitializers = [];
    let _chips_decorators;
    let _chips_initializers = [];
    let _chips_extraInitializers = [];
    var ChildrenDocs = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.name = __runInitializers(this, _name_initializers, 'Ada');
            this.pingName = (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _pingName_initializers, 'Ada'));
            this.chips = (__runInitializers(this, _pingName_extraInitializers), __runInitializers(this, _chips_initializers, [
                { id: 1, label: 'Coffee', count: 0 },
                { id: 2, label: 'Tea', count: 0 },
                { id: 3, label: 'Code', count: 0 },
            ]));
            this.inputChildSample = (__runInitializers(this, _chips_extraInitializers), `@Component({
    selector: 'Badge',
    useTemplate: template,
    useStyleSheets: []
})
class Badge extends ReactiveClass {
    @Input() label = '';
}`);
            this.inputParentSample = `@Component({
    selector: 'Parent',
    useTemplate: template,
    useStyleSheets: []
})
class Parent extends ReactiveClass {
    @State() name = 'Ada';
}

// parent.template.be
<Badge $label={name} />`;
            this.inputTabs = [
                { key: 'child', label: 'badge.ts', code: this.inputChildSample },
                { key: 'parent', label: 'parent.ts', code: this.inputParentSample },
            ];
            this.inputSetterSample = `// @Input setter -- same as @State, plus an identity check
set(val){
    if(value === val) return;   // same number, string, or object ref
    value = val;
    this.runSubscribers();      // CHILD tick, not parent
}`;
            this.storageSample = `// View.buildComponent -- runs in the PARENT's View
const anchor = document.createComment('component:Badge');
const child = new Badge();              // child's View + init already ran
applyProps(child, htmlObj.props);       // first paint: child.label = 'Ada'
anchor.nodeChild = child.view.root;     // child's real DOM, not a wrapper
queueMicrotask(() => insertAfter(anchor, child.view.root));

parent.reactiveElements.set(anchor, () => {
    applyProps(child, htmlObj.props);   // later parent ticks: re-apply $label
});`;
            this.afterMountSample = `parent.view.root
  Text("Ada")
  <!--component:Badge-->          // parent Map key: applyProps
      nodeChild = child.view.root
        <span>Ada</span>          // child's DOM, after the comment

parent.reactiveElements
  Text -> textContent = this.name
  Comment("component:Badge") -> applyProps(badge, { label: fn })

child.reactiveElements
  Text -> textContent = this.label

// parent.name = 'Bo'
//   parent Map runs: {name} becomes Bo, then applyProps writes child.label
//   @Input sees a new string, child Map runs: the span becomes Bo
// the parent never walks the child's interpolations`;
            this.storageTabs = [
                { key: 'build', label: 'buildComponent', code: this.storageSample },
                { key: 'after', label: 'after mount', code: this.afterMountSample },
            ];
            this.commentJobs = [
                { title: 'Stable slot', body: 'The parent needs one node to sit next to. The child may stamp several siblings. The comment is what buildNodeTree returns.' },
                { title: 'Map key', body: 'The parent updater that re-applies $props and @handlers lives on the comment, not on the child span -- that span belongs to the child Map.' },
                { title: 'Insertion cursor', body: 'child.view.root is inserted after the comment, once the comment has a parentNode. First paint is a queueMicrotask for that reason.' },
                { title: 'Unmount handle', body: 'unMountNode(comment) walks nodeChild, removes the child DOM, and drops the parent Map entry. That is how a child disappears when a parent @if / @for tears the hole down.' },
            ];
            this.pingChildSample = `@Component({
    selector: 'Badge',
    useTemplate: template,
    useStyleSheets: []
})
class Badge extends ReactiveClass {
    @Input() label = '';
    onPing?: () => void;    // plain field, not @Input

    ping(){
        this.onPing?.();
    }
}

// badge.template.be
<button @click={ping}>{label}</button>`;
            this.pingParentSample = `class Parent extends ReactiveClass {
    @State() name = 'Ada';
    ping(){ this.name = this.name + '!'; }
}

// parent.template.be
<Badge $label={name} @onPing={ping} />`;
            this.pingTabs = [
                { key: 'child', label: 'badge.ts', code: this.pingChildSample },
                { key: 'parent', label: 'parent.ts', code: this.pingParentSample },
            ];
            this.listSample = `@for(chip : chips; key = trackChipById){
  <DemoChip $label={chip.label} $count={chip.count} @onBump={() => bumpChip(chip.id)} />
}`;
        }
        setName(e) {
            this.name = e.target.value;
        }
        ping() {
            this.pingName = this.pingName + '!';
        }
        trackChipById(chip) {
            return chip.id;
        }
        bumpChip(id) {
            const chip = this.chips.find(c => c.id === id);
            if (chip)
                chip.count++;
        }
    };
    __setFunctionName(_classThis, "ChildrenDocs");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _name_decorators = [(0, core_1.State)()];
        _pingName_decorators = [(0, core_1.State)()];
        _chips_decorators = [(0, core_1.State)()];
        __esDecorate(null, null, _name_decorators, { kind: "field", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(null, null, _pingName_decorators, { kind: "field", name: "pingName", static: false, private: false, access: { has: obj => "pingName" in obj, get: obj => obj.pingName, set: (obj, value) => { obj.pingName = value; } }, metadata: _metadata }, _pingName_initializers, _pingName_extraInitializers);
        __esDecorate(null, null, _chips_decorators, { kind: "field", name: "chips", static: false, private: false, access: { has: obj => "chips" in obj, get: obj => obj.chips, set: (obj, value) => { obj.chips = value; } }, metadata: _metadata }, _chips_initializers, _chips_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        ChildrenDocs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return ChildrenDocs = _classThis;
})();
exports.ChildrenDocs = ChildrenDocs;
